import { createSlice } from "@reduxjs/toolkit";

type InitialStateType = {
    supplier: number,
    department: number,
    subDepartment: number,
    stockGroup: number,
    manufacturer: number,
    minOrderQty: number,
    cartonSize: number,
    minStock: number,
    maxStock: number,
    gst: string,
    active: number,
    ethical: number,
    locked: number,
    loading: boolean,
};

const initialState: InitialStateType = {
    supplier: 0,
    department: 0,
    subDepartment: 0,
    stockGroup: 0,
    manufacturer: 0,
    minOrderQty: 0,
    cartonSize: 0,
    minStock: 0,
    maxStock: 0,
    gst: "",
    active: 0,
    ethical: 0,
    locked: 0,
    loading: false,
};

export const bulkEditSlice = createSlice({
    name: "bulkEditSlice",
    initialState: {
        ...initialState,
    },
    reducers: {
        updateBulkEditField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        },
        cleanBulkEditDetails: (state) => {
            return {
                ...state,
                ...initialState,
            };
        },
    },
});

export const { updateBulkEditField, cleanBulkEditDetails } = bulkEditSlice.actions;

export default bulkEditSlice.reducer;